import { connect } from 'react-redux';
import formListActions from '../../stores/FormList/actions';

import FormList from '../components/formList';

const mapStateToProps = (state) => {
  const { formList } = state;
  const {
    isInitializing,
    forms,
    isCreatingForm,
    newFormId
  } = formList;

  return {
    isInitializing,
    forms,
    isCreatingForm,
    newFormId
  };
};

const mapDispatchToProps = dispatch => ({
  onFormListInitialize: token => dispatch(formListActions.formListInit(token)),
  onNewForm: token => dispatch(formListActions.createForm(token))
});

export default connect(mapStateToProps, mapDispatchToProps)(FormList);
